import styled from 'styled-components';

export const ModalContentWrap = styled.div`
    width: 100%;
    overflow-y: auto;
    height: 100%;

    max-height: calc(90vh - 8.126rem);
`;
